import { priceFormat } from 'util/prices';
import { repareImage } from 'newFunctions/repareDataService';
import ModalProductTC from '../../Modal'
import styles from '../styles.module.sass'

const ModalProductSimple = (props) => {

    const {
        producto,
        handleCloseModal,
        clickAceptProduct,
        isMobile,
        title
    } = props

    return(
        <ModalProductTC
            onClose={handleCloseModal} 
            isMobile={isMobile} 
            type={isMobile === 'desktop' ? '' : 'full'} 
            title={title} 
            closeBody="modalPromos"
        >
            <ModalProduct 
                producto={producto} 
                handleCloseModal={handleCloseModal} 
                clickAceptProduct={clickAceptProduct}
            />
        </ModalProductTC>
    )   
}

const ModalProduct = (props) => {

    const {
        producto,
        handleCloseModal,
        clickAceptProduct
    } = props

    const image = producto?.pictures?.length >= 1 ? producto?.pictures[0]?.source : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABiCAYAAACrpQYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR/SURBVHgB7Z1bctpIFIYPMr488mojV8EKhqwgeAfMCsZZwXhWELwCe1YwzAriWYHJCkxWgKYw9mN49o38xxFEvgUIOq0D9X9VFBKIi/rT6VZf1BIhhBBCiGtKUgD9fr+ys7Pz58PDQwurNTwq6Vs9vPa5XC6f7u7uJmLAYDBo4qkVRdH70L/9M4KLuL6+/ogdbs/arlQqdfH4kFeiXF5eNpD4J+PxuDlrW2zXxu8eS0CCidAo2N7e/jRPQmTJI1Gurq5UwJEsRu/m5uagXq+PJADBRCAxzheVkKEHIb8vGh2/Kn+CRuXe3t6BBCCSAGh2tIQEpYHs7BzfU5v3A7rt1tbWxTK/q5/FAbRoJP0S5hGhCYJEvJAfheIyJIiMg1mRkf7muXwvjJdlhCyqbp1FmUfE/f19U/KRoGgCf9Is560N9L0cJSiVzc3NQzHGXASO4D8kXxrI9/956830vZrkCMqKphhjLgL5bF7RkP3O1mt5d1oWtSR/fhNjQhTWuYtQkOAnWjeYrKflQltWlCBnTVYgy5hmUWm5YIV5XaIsxuDI/YwEq4kNDTRZtNEsMYaImtjxvxgTIiJ6YghOBrTN6lAMwcF0JsaYi7i9ve2IbWhrGVQTO0YbGxtdMcZchFaEcMT+LSsK/vu/IVpjH2vWk2ZphKCehVicbup3NmQ16aGMM4lolYwc40wP1lLOzQFkcR6bbSI0QbSFEopEA+FjaTgcfhWjSheZm5HWI7ISHsNECgLR2UJ+fCIBQLn1F86GzE9L3+JZcVB5UaEror92AposgvSGKUiIURzHiRQEcqIn6yvdxLFOUIQTKMIJFOEEinACRTiBIpxAEU6gCCc8r1lXULs9lOJoSiDQvPEe+yoF8qR9Txv9+sLW16JJIu2cEFIo6uCxh24wGJxqJ7yQ4Gg38v7+/tF0ELL21D1vhtahMHjqSEHocM1no7mPsZ7M81nt9s0eXN72Bel8hPT+AgldXZ8W1tr8DRlnMHSS2bhfrVY7UhAoTJv4D9N1/Lfu5I/PIr1EayrC275g+T/sSzJZ5+mrEyjCCRThBIpwAkU4gSKcQBFOoAgnUIQTKMIJFOEEinACRTiBIpxAEU7wLqKbWR6Vy+VE1hTXIuI47qBX6wMW9fmgyGs3rDGfeWBZVIYU2MUZCpYRTqAIJ1CEE9yXEToEVIfGFDUxbihcR4RK0DmZ0hloLn42l9+q41pEOjfIhAqiYlXn85iJaxGIhg6eEl2GlC/zDi5bRbxX6HRa6HeQ8A7LaxsNivvCOp341nQWNA/w9NUJFOEEinCCaxF6zYbe7mA4HI51lmNZY1yLuLu7O5xc3KGzHGdnPl43vNcjatl1i3nGvcAywgkU4QSKcAJFOIEinEARTqAIJ1CEEyjCCRThBIpwAkU4gSKcQBFOoAgnPLmNcnq/oX7mpQR9AokUxCs3n5r7xkuv3GDK1b5EUVTPDiF9cT9r3uomCEm1Wq1nX3iRNcHcsRBTXkvjFyLiOD5NL5da+0FdoUG69jRt06ugCCGEELJKfAOeovPz75iFkQAAAABJRU5ErkJggg=='

    return(
        <article className={styles?.cardModalProduct}>
            <div onClick={handleCloseModal} className={styles?.closeBtn} aria-hidden >X</div>
            {/* {producto?.pricing?.percentage_discount
                ?
                    <p className={styles?.discount}>-{producto?.pricing?.percentage_discount}%</p>
                : null
            } */}
            
            <div className={styles?.contImagesSingle}>
                <img src={repareImage(image)} alt={producto?.title} className={styles?.imageProductSingle} loading="lazy" decoding="async" fetchPriority="High" />
                <a href={`/producto/${producto?.id}/${producto?.title_seo}`} alt={producto?.title} target="_blank" className={styles?.link} rel="noreferrer" >Ver detalle</a>
            </div>
            
            <div className={styles?.contProductInt}>
                <p className={styles?.titleSingle}>{producto?.title}</p>
                <div className={styles?.contPrices}>
                    <p className={styles?.salesPriceSingle}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                </div>

                <p className={styles?.descriptionCant}>Cantidad: 1</p>
                {/* <p className={styles?.description}>{producto?.description}</p> */}
                <div>
                    <div className="btn secondaryButton btn-block" onClick={clickAceptProduct} aria-hidden="true" >Agregar</div>
                </div>
            </div>
        </article>
    )
}

export default ModalProductSimple